export default "__VITE_ASSET__DKS$9cd4__"